import { render } from "./AgenteJornada.vue?vue&type=template&id=0765a79e&scoped=true"
import script from "./AgenteJornada.vue?vue&type=script&lang=ts"
export * from "./AgenteJornada.vue?vue&type=script&lang=ts"

import "./AgenteJornada.vue?vue&type=style&index=0&id=0765a79e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0765a79e"

export default script